// Base path for the conversations-service question-classification summary API.
// The summary endpoint lives at `${QUESTION_INSIGHTS_API}/summary`.
export const QUESTION_INSIGHTS_API = "/api/conversations/v1/classifications";

export const QUESTION_INSIGHTS_PAGE_TITLE = "AI Session Query Insights";
